export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith",
    "Dr. Emily Johnson",
    "Dr. Michael Brown",
    "Dr. Sarah Davis",
    "Dr. William Wilson",
    "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee",
    "Dr. Patricia Taylor",
    "Dr. James Anderson",
    "Dr. Barbara Thomas",
    "Dr. David Jackson",
    "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia",
    "Dr. Jennifer Harris",
    "Dr. Charles Clark",
    "Dr. Jessica Lewis",
    "Dr. Thomas Robinson",
    "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young",
    "Dr. Matthew Hall",
    "Dr. Donna Allen",
    "Dr. Steven King",
    "Dr. Michelle Wright",
    "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green",
    "Dr. Kevin Adams",
    "Dr. Laura Baker",
    "Dr. Mark Nelson",
    "Dr. Angela Carter",
    "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez",
    "Dr. Eric Roberts",
    "Dr. Deborah Turner",
    "Dr. Jason Phillips",
    "Dr. Rebecca Campbell",
    "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta",
    "Dr. Priya Iyer",
    "Dr. Rakesh Nair",
    "Dr. Neha Sharma",
    "Dr. Vivek Rao",
    "Dr. Aarti Desai"
  ]
};

export const diseaseOptions = [
  'Hypertension',
  'Diabetes Mellitus',
  'Asthma',
  'Pneumonia',
  'COVID-19',
  'Tuberculosis',
  'Anemia',
  'Heart Failure',
];

export const riskFactorOptions = [
  'Smoking',
  'Obesity',
  'Hypertension',
  'Diabetes',
  'High Cholesterol',
  'Physical Inactivity',
  'Family History',
];

export const complicationsOptions = [
  'Diabetes',
  'Hypertension',
  'Asthma',
  'Heart Disease',
  'Stroke',
  'Chronic Kidney Disease',
  'COPD',
  'Liver Cirrhosis',
  'Anemia',
  'Arthritis',
  'Obesity',
  'Cancer',
  'Thyroid Disorder',
  'Depression',
  'Anxiety',
  'Osteoporosis',
  'Gastroesophageal Reflux Disease (GERD)',
  'Sleep Apnea',
  'Allergies',
  'Autoimmune Disease',
  'Peripheral Artery Disease',
  'Infections',
  'Sepsis',
  'Pulmonary Embolism',
  'Venous Thromboembolism',
  'Pregnancy Complications',
];

export const unableConsentReasons = [
  "Patient unconscious",
  "Patient sedated",
  "Cognitive impairment",
  "Severe pain or distress",
  "Emergency situation",
  "Language barrier",
  "Hearing impairment",
  "Developmental disability",
  "Under influence of medication or substances",
];

export const signatureDatetimeMap = {
  patient_signature: "patient_signature_date_time",
  witness_signature: "witness_signature_date_time",
  doctor_anaesthetist_signature: "doctor_anaesthetist_signature_date_time",
  interpreter_signature: "interpreter_signature_date_time",
  patient_rep_signature: "patient_rep_signature_date_time",
  witness_signature_unable_consent: "witness_signature_unable_consent_date_time",
  doctor_signature_unable_consent: "doctor_signature_unable_consent_date_time",
  interpreter_signature_unable_consent: "interpreter_signature_unable_consent_date_time"
};
